import * as S from './styles';
import { RiPlayMiniLine, RiPlayReverseMiniLine, RiSkipForwardMiniLine, RiSkipBackMiniLine } from "react-icons/ri";

export const Paginator = ({ currentPage, totalPages, handlePagination }: any) => {
    return (
        <S.Pagination>
            <S.PageControl>
                <S.PageControlItem onClick={() => handlePagination(1)} disabled={currentPage === 1}>
                    <RiSkipBackMiniLine />
                </S.PageControlItem>
                <S.PageControlItem onClick={() => handlePagination(currentPage - 1)} disabled={(currentPage - 1) === 0}>
                    <RiPlayReverseMiniLine />
                </S.PageControlItem>
            </S.PageControl>
            <S.Pages>
                <S.CurrentPage type="text" value={currentPage} readOnly />
                <S.TotalPages>de <b>{totalPages}</b></S.TotalPages>
            </S.Pages>
            <S.PageControl>
                <S.PageControlItem onClick={() => handlePagination(currentPage + 1)}>
                    <RiPlayMiniLine />
                </S.PageControlItem>
                <S.PageControlItem onClick={() => handlePagination(totalPages)}>
                    <RiSkipForwardMiniLine />
                </S.PageControlItem>
            </S.PageControl>
        </S.Pagination>
    )
}

export default Paginator